<!-- 模块-办理油卡 -->
<template>
  <van-popup class="popup" v-model="ifShow" position="right" :overlay="false">
    <div class="popup_title">
      <span>快速办理油卡</span>
      <van-button type="default" round size="small" @click="close">返 回</van-button>
    </div>

    <v-touch class="popup_body" @swiperight="close">
      <van-form @submit="on">
        <van-field
          readonly
          v-model="s_name"
          label="办卡站点:"
          placeholder="选择办卡站点"
          @click="show_site = true"
          :rules="[{required: true, message: '请选择办卡站点' }]"
        />

        <van-field label="办卡种类:" :rules="[{required: true, message: '请选择办卡种类' }]">
          <template #input>
            <van-radio-group v-model="classify_id" direction="horizontal">
              <van-radio v-for="(val, key) in data" :key="key" :name="val.classify_id">{{val.name}}</van-radio>
            </van-radio-group>
          </template>
        </van-field>

        <div class="footer">
          <van-button round block type="info" native-type="submit" :loading="ifOn" :disabled="ifOn">办理油卡</van-button>
        </div>
      </van-form>
    </v-touch>

    <!-- 选择站点 -->
    <van-popup v-model="show_site" round position="bottom">
      <van-picker show-toolbar :columns="site_columns" @cancel="show_site = false" @confirm="choose_site"/>
    </van-popup>

  </van-popup>
</template>

<script>
export default {
  name: 'card_reg',
  data () {
    return {
      ifShow: false,
      ifOn: false,
      data: [],
      site_data: [],
      site_columns: [],
      show_site: false,
      s_id: '',
      s_name: '',
      classify_id: ''
    }
  },

  methods: {
    // 显示弹层
    show () {
      this.get_site()
    },

    // 获取站点数据
    get_site () {
      this.ax(this, 'sel_site_list', {status: 1}, (res) => {
        if (res.err_num === 0) {
          this.site_data = res.data
          this.site_columns = []

          this.site_data.forEach(val => {
            this.site_columns.push(val.name)
          })

          // 单站版自动选择
          if (this.site_data.length === 1) {
            this.choose_site(null, 0)
          }

          this.get_data()
        }
      }, 'all')
    },

    // 获取分组数据
    get_data () {
      this.ax(this, 'sel_web_card_classify', {}, (res) => {
        if (res.err_num === 0) {
          this.data = res.data
          // 只启用单种类时自动选中、自动办理
          if (this.data.length === 1) {
            this.classify_key = 0
            this.on()
          } else {
            this.ifShow = true
          }
        }
      }, 'all')
    },

    // 选中站点
    choose_site (val, key) {
      this.s_id = this.site_data[key].s_id
      this.s_name = this.site_data[key].name
      this.show_site = false
    },

    // 提交申请
    on () {
      // 计算油品种类
      let oilKind = ''
      this.data.forEach(val => {
        if (val.classify_id === this.classify_id) {
          oilKind = val.kind
        }
      })

      let data = {
        s_id: this.s_id,
        classify_id: this.classify_id,
        oil_kind: oilKind
      }

      this.ax(this, 'reg_web_card_user', data, (res) => {
        if (res.err_num === 0) {
          this.close()
        }
      }, 'on')
    },

    // 关闭
    close () {
      this.$emit('up_data')
      this.ifShow = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/card/reg.vue